import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Modal affiché quand un utilisateur anonyme tente d'accéder à du contenu réservé
 */
const AccessDeniedModal = ({ isOpen, onClose, message }) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 1024);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!isOpen) return null;

  const {
    title = '🔒 Contenu réservé',
    message: msg = 'Ce contenu est réservé aux élèves inscrits.',
    ctaText = 'Créer mon compte',
    ctaLink = '/login',
    variant = 'anonymous'
  } = message || {};
  const perksTitle = variant === 'no-teacher'
    ? '🔑 Avec le code de ton professeur :'
    : '✨ Avec un compte élève :';

  const handleUpgrade = () => {
    navigate(ctaLink);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className={`bg-white rounded-2xl shadow-2xl w-full ${isMobile ? 'max-w-xs p-4' : 'max-w-md p-8'}`}>
        <div className={`text-center ${isMobile ? 'mb-3' : 'mb-6'}`}>
          <div className={`${isMobile ? 'text-4xl mb-2' : 'text-6xl mb-4'}`}>{title.split(' ')[0]}</div>
          <h2 className={`font-bold text-gray-800 ${isMobile ? 'text-lg mb-1' : 'text-2xl mb-2'}`}>
            {title.substring(title.indexOf(' ') + 1)}
          </h2>
        </div>

        <p className={`text-gray-600 text-center ${isMobile ? 'text-sm mb-3' : 'mb-6'}`}>{msg}</p>

        <div className={`bg-gray-100 border-2 border-gray-300 rounded-lg ${isMobile ? 'p-3 mb-3' : 'p-4 mb-6'}`}>
          <p className="text-xs text-gray-900 font-semibold mb-1">{perksTitle}</p>
          <ul className="text-xs text-gray-800 space-y-0.5">
            <li>✅ Accès à tous les exercices</li>
            <li>✅ Progression sauvegardée partout</li>
            <li>✅ Classements et défis</li>
            <li>✅ Statistiques détaillées</li>
          </ul>
        </div>

        <div className="flex flex-col gap-2">
          <button
            onClick={handleUpgrade}
            className={`w-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-semibold rounded-full transition-colors ${isMobile ? 'py-2 text-sm' : 'py-3'}`}
          >
            {ctaText}
          </button>
          <button
            onClick={onClose}
            className={`w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-full transition-colors ${isMobile ? 'py-1.5 text-sm' : 'py-2'}`}
          >
            Continuer en découverte
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccessDeniedModal;
